<div class="search-radios" [class.search-radios--open]="helper.FORM" [class.search-radios--filled]="this.model !== undefined">

  <!-- field -->
  <div
    class="inner"
    (hidden)="helper.FORM = null"
    [ngbPopover]="popContent"
    #popContentRef="ngbPopover"
    placement="bottom-left bottom-right"
    popoverClass="popover--search"
    [container]="'body'"
    [autoClose]="'outside'"
    (click)="openForm(popContentRef)">
    <!-- empty -->
    @if (this.model === undefined) {
      <span class="empty">{{placeholder}}</span>
    }
    <!-- filled -->
    @if (this.model !== undefined) {
      <span class="label">{{placeholder}}:</span>
      <!-- model -->
      <div class="d-flex align-items-center">
        <span class="value">{{this.helper.selected?.title}}</span>
      </div>
    }
    <!-- icon -->
    <i class="im-icon im-icon-triangle-rounded-down"></i>
  </div>

  <!-- popover -->
  <ng-template #popContent>
    @if (helper.FORM) {
      <div class="popover--inner">
        <div class="options">
          @for (option of options; track option) {
            <div class="option" (click)="select(option)">
              <div class="fake-radio" [class.active]="option.value === model">
                <span></span>
              </div>
              <div class="title">{{option.title}}</div>
            </div>
          }
        </div>
        @if (allowClear) {
          <div class="clear-wrap" (click)="clear()">Selectie leegmaken</div>
        }
      </div>
    }
  </ng-template>
</div>